import React from 'react';
import PropTypes from 'prop-types';
import Logo from '../common/logo';
import { userIsCreator } from '../../services/users';
import { useGetUserProfileQuery } from '../../app/smorgAppSyncGraphQLApiCustomHooks';

const TopNavBarMobile = ({ screenTitle }) => {
  const { data: userProfile } = useGetUserProfileQuery();

  const isSmorgStudio = userIsCreator(userProfile);

  return (
    <div className="topNavBarMobile">
      {screenTitle ? (
        <div className="screen-title" style={{ flexGrow: 1 }}>
          {screenTitle}
        </div>
      ) : (
        <Logo userIsCreator={isSmorgStudio} />
      )}
    </div>
  );
};

TopNavBarMobile.propTypes = {
  screenTitle: PropTypes.string,
};

TopNavBarMobile.defaultProps = {
  screenTitle: null,
};

export default TopNavBarMobile;
